import bilionpassLogo from '@/assets/svg/bilionpass.svg'

const LOGO_ITEMS = Array.from({ length: 2 })

export const LogoMarquee = () => (
  <section className="relative h-[157px] w-full overflow-hidden">
    <style>
      {`
        @keyframes logo-marquee {
          from {
            transform: translateX(-50%);
          }
          to {
            transform: translateX(0);
          }
        }
      `}
    </style>
    <div
      className="flex h-full w-max items-center"
      style={{ animation: 'logo-marquee 26s linear infinite' }}
    >
      {LOGO_ITEMS.map((_, index) => (
        <img
          key={index}
          src={bilionpassLogo}
          alt=""
          className="h-[157px] w-auto shrink-0 pr-[128px]"
          draggable={false}
        />
      ))}
    </div>
  </section>
)
